<div>
  <p-table
    [value]="gradings"
    selectionMode="single"
    [(selection)]="selectedGrading"
    (onRowSelect)="onRowSelect()"
    [autoLayout]="true"
    [loading]="loading"
  >
    <ng-template pTemplate="header">
      <tr>
        <th>Grade</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-data>
      <tr [pSelectableRow]="data">
        <td>
          <span [style.color]="data.colour" [class]="data.iconClass + ' text-lg mr-2'"></span>
          {{ data.description }}
        </td>
      </tr>
    </ng-template>
  </p-table>
  <div style="text-align: right" class="mt-2">
    <button type="button" pButton icon="fa fa-plus" (click)="addGrading()" label="Add"></button>
  </div>
</div>

<p-dialog
  [header]="isNewGrading ? 'Add Grading' : 'Edit Grading'"
  [(visible)]="showEditGrading"
  [modal]="true"
  [style]="{ width: '500px' }"
  (onHide)="updateGradingDto = null"
>
  <div *ngIf="updateGradingDto">
    <div class="grid">
      <div class="col-4">
        <label>Icon Class</label>
      </div>

      <div class="col-8 px-2">
        <input pInputText class="w-full" [(ngModel)]="updateGradingDto.iconClass" />
      </div>

      <div class="col-4">
        <label>Icon Colour</label>
      </div>

      <div class="col-8 px-2">
        <p-colorPicker [(ngModel)]="updateGradingDto.colour" [inline]="true"></p-colorPicker>
        <div>{{ updateGradingDto.colour }}</div>
        <div class="w-full h-2rem" [style.backgroundColor]="updateGradingDto.colour"></div>
      </div>

      <div class="col-4">
        <label>Description</label>
      </div>

      <div class="col-8 px-2">
        <input pInputTextarea class="w-full" [(ngModel)]="updateGradingDto.description" />
      </div>

      <div class="col-4">
        <label>Preview</label>
      </div>

      <div class="col-8 px-2">
        <span
          [style.color]="updateGradingDto.colour"
          [class]="updateGradingDto.iconClass + ' text-lg mr-2'"
        ></span>
        {{ updateGradingDto.description }}
      </div>
    </div>
  </div>
  <p-footer>
    <button
      (click)="saveGrading()"
      pButton
      [label]="saving ? 'Wait..' : 'Save'"
      [disabled]="saving"
    ></button>
  </p-footer>
</p-dialog>
